import {
  PutIntegrationRequestBodyType,
  PutIntegrationResponseBodyType,
} from "@intelligems/ig-types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "../api";
import { integrationKeys } from "../queryKeys";
import { ApiRequest } from "../types/api";

const putIntegration = async (
  payload: ApiRequest<PutIntegrationRequestBodyType>
) => {
  const resp = await api.put<PutIntegrationResponseBodyType>(
    `/v2/integrations`,
    payload.body
  );
  return resp.data;
};

export const usePutIntegration = () => {
  const queryClient = useQueryClient();
  return useMutation<
    PutIntegrationResponseBodyType,
    Error,
    ApiRequest<PutIntegrationRequestBodyType>,
    any
  >({
    mutationFn: async (data: ApiRequest<PutIntegrationRequestBodyType>) =>
      putIntegration(data),
    onSuccess: async () => {
      void queryClient.invalidateQueries({ queryKey: integrationKeys.all });
    },
  });
};
